import state from './schedule.state'
import mutations from './schedule.mutations'
import actions from './schedule.actions'

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
